import Honeybadger from "@honeybadger-io/js"

// Shared handler for dropping a catalog baustein from the picker into an LV or
// offer tree (boq-tree and billing-offer-tree both delegate here). The transient
// Sortable clone is removed immediately — on success the streamed tree re-render
// shows the inserted rows. The success path is ALWAYS a Turbo Stream, so any
// other response (or a network error) is surfaced via the error message instead
// of failing silently.
export async function insertCatalogEntry(event, { url, errorMessage }) {
  const entryId = event.item.dataset.catalogEntryId
  // Set by catalog_entry_row_controller#syncDataset when the row is expanded and every
  // position has been unticked. An empty catalog_item_ids means "the whole Baustein" to
  // the server, so this state has to be refused here — the Insert button refuses it too.
  const selectionEmpty = event.item.dataset.catalogSelectionEmpty === "true"
  event.item.remove()
  if (!entryId || !url || selectionEmpty) return

  const parentId = event.to.dataset.parentId || ""
  const position = event.newIndex + 1
  const token = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
  // The picker row publishes its per-position selection onto the element it is dragged
  // from (catalog_entry_row_controller#syncDataset), so dropping a partially ticked
  // Baustein inserts exactly what the insert button would have.
  const itemIds = (event.item.dataset.catalogItemIds || "").split(",").filter(Boolean)
  const wrapInGroup = event.item.dataset.catalogWrapGroup !== "false"

  try {
    const response = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": token,
        Accept: "text/vnd.turbo-stream.html",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        catalog_entry_id: entryId,
        parent_id: parentId,
        position: position,
        catalog_item_ids: itemIds,
        wrap_in_group: wrapInGroup,
      }),
    })
    const contentType = response.headers.get("Content-Type") || ""
    if (contentType.includes("text/vnd.turbo-stream.html")) {
      // The success re-render, or the server's error flash stream.
      Turbo.renderStreamMessage(await response.text())
      return
    }
    throw new Error(`catalog insert failed: ${response.status}`)
  } catch (error) {
    Honeybadger.notify(error, { context: { component: "catalog-insert" } })
    showError(errorMessage)
  }
}

function showError(message) {
  if (!message) return
  if (window.Turbo && typeof window.Turbo.toast === "function") {
    window.Turbo.toast(message, "error")
  } else {
    alert(message)
  }
}
